export const displayFrequency = (item) => {
  if (!item.frequency) {
    return "";
  }
  return `every ${item.frequency.count > 1 ? `${item.frequency.count} ` : ""}${
    item.frequency.period
  }${item.frequency.count > 1 ? "s" : ""}`;
};

export const displayMembershipDuration = (membership) => {
  if (membership && membership.duration) {
    const action = membership.auto_renews ? "Renews every" : "Expires after";
    const plural = membership.duration.count > 1 ? "s" : "";
    return `${action} ${membership.duration.count} ${membership.duration.period}${plural}`;
  }
  return "";
};
